import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {Lang, Theme, WikiUserSettings} from '~shared/models';

import {updateUserSettings} from './thunks';

export type UserSettingsState = WikiUserSettings;

const initialState: UserSettingsState = {
    language: Lang.Ru,
    theme: Theme.Light,
    themeSettings: {
        systemLightTheme: Theme.Light,
        systemDarkTheme: Theme.Dark,
    },
    propose_content_translation: false,
    favoritesTable: [],
    navigationTreeOpened: true,
    show_features_pages: false,
};

export const {reducer, actions} = createSlice({
    name: 'user-settings',
    initialState,
    reducers: {
        setSettings(state, {payload}: PayloadAction<Partial<WikiUserSettings> | undefined>) {
            Object.assign(state, payload);
        },
    },
    extraReducers: (builder) =>
        builder.addCase(updateUserSettings.pending, (state, {meta}) => {
            const updatedSettings = meta.arg;
            Object.assign(state, updatedSettings);
        }),
});
